import React, { createContext, useContext, useReducer } from 'react';
import { acquittalsReducer, initialState } from './reducer';

const AcquittalsContext = createContext();

export const AcquittalsProvider = ({ children }) => {
    const [state, dispatch] = useReducer(acquittalsReducer, initialState);
    return <AcquittalsContext.Provider value={[state, dispatch]}>{children}</AcquittalsContext.Provider>;
};

export const useAcquittalsContext = () => {
    const context = useContext(AcquittalsContext);
    if (!context) {
        throw new Error('useAcquittalsContext must be used within an AcquittalsProvider');
    }
    return context;
};
